import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  let page;
  if (path.startsWith("/admin/login")) page = <AdminLogin />;
  else if (path.startsWith("/admin")) page = <AdminDashboard />;
  else page = <Home />;

  return (
    <>
      <Toaster position="top-center" theme="dark" richColors />
      {page}
    </>
  );
}

export default App;
